import { render, staticRenderFns } from "./proof.vue?vue&type=template&id=c6e66f24&scoped=true&"
import script from "./proof.vue?vue&type=script&lang=js&"
export * from "./proof.vue?vue&type=script&lang=js&"
import style0 from "./proof.vue?vue&type=style&index=0&id=c6e66f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e66f24",
  null
  
)

export default component.exports